// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-content {
  overflow: hidden;
  position: relative;
  width: 100%;
}
.home-content img {
  width: 100%;
  height: auto;
}
.home-content .banner-text {
  right: auto;
  top: 100px;
  left: 20px;
  display: block;
  background: rgba(255, 255, 255, 0.9);
  padding: 2.4em 3.12em 1.6em;
  position: absolute;
  color: #de3a6b;
}
.home-content .banner-text:before {
  content: "";
  display: block;
  height: 8px;
  position: relative;
  top: -2.4em;
  left: 0;
  right: 2em;
  z-index: 1;
  background-color: #de3a6b;
}
.home-content .banner-img {
  background-position: 20% 50%;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100vh;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
